import React from 'react';
import Alert from '../../../components/Alert';
import { connect } from 'react-redux';
import Row from '../../../components/tag/Row';
import { FormattedMessage } from 'react-intl';
import { showTimelineModal } from '../data/actions';

const TimelineTopAlert = (props) => {
  let { showTimelineModal } = props;
  return (
    <>
      <Alert type="info" className={'ot-timeline-common-info'}>
        <Row>
          <FormattedMessage
            id={`${module.id}.common.info`}
            className={'ot-timeline-alert__description'}
            tagName={'p'}
          />
          <FormattedMessage id={`${module.id}.common.info.link`}>
            {(txt) => (
              <a
                className={'ot-timeline-alert__link'}
                onClick={() => showTimelineModal()}
              >
                {txt}
              </a>
            )}
          </FormattedMessage>
        </Row>
      </Alert>
    </>
  );
};

export default connect(null, { showTimelineModal })(TimelineTopAlert);
